import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import { Link } from 'react-router-dom';

import { Page } from '../shared';

import ReactTooltip from 'react-tooltip';

import {
  beginEditingTeam
} from '../../actions/teams';
import {
  fetchCurrentSprintsForTeam
} from '../../actions/sprint';

import {
  currentUserIsAdmin,
  currentUserIsSalesLeader,
  currentUserIsManager,
  getSprintStatusTextForEmployee,
  getRatingClass,
  getIcon,
} from '../../util';

import { UpdateTeamModal } from '../modals';

class AllTeamsPage extends Component {

  state = {
    searchText: '',
    pageMessage: null,
    currentTeamSprints: {}
  }

  componentWillMount(){
    console.log('TOOD: FETCH TEAM CURRENT SPRINT DATA');
  }

  fetchCurrentSprintsForTeam(team){
    console.log('fetching data for: ', team);

  }

  componentWillReceiveProps(nextProps){
    if(nextProps.team && _.size(nextProps.team) > 0){
      console.log('team: ', nextProps.teams);
      this.fetchCurrentSprintsForTeam(nextProps.teams);
    }
  }

  employeesMappedById(){
    const employees = this.props.employees;

    return _.keyBy(employees, '_id');
  }

  userData(userId){
    return this.employeesMappedById()[userId];
  }

  renderTeamForAdmin(team){
    return (
      <div className="team" key={team._id}>
        <div className="name">{team.name}</div>

        <h5>LEADER{team.leaders.length > 1 ? 'S' : ''}</h5>
        <ul>
          {_.map(team.leaders, leader => {
            const leaderData = this.userData(leader);

            return <Link key={leader} to={`/people/${leader}/profile`}><li className={`${leaderData._deleted ? 'deleted' : ''}`}>
              <div className="member-name">{leaderData.firstName} {leaderData.lastName}</div>
            </li></Link>
          })}
        </ul>

        <h6>MEMBERS</h6>
        <ul>
          {_.map(team.members, member => {
            const memberData = this.userData(member);

            return <Link key={member} to={`/people/${member}/profile`}><li className={`${memberData._deleted ? 'deleted' : ''}`}>
              <div className="member-name">{memberData.firstName} {memberData.lastName}</div>
            </li></Link>
          })}
        </ul>

        {this.renderTeamLinks(team)}

        <div className="actions">
          <button onClick={() => {this.beginEditingTeam(team); } }>Edit</button>
        </div>

      </div>
    )
  }

  coachingDisabled(){
    const { coachingIQDisabled } = this.props.organization || {};
    return coachingIQDisabled;
  }
  userLink(userId){
    const userIsArchived = this.userData(userId) && this.userData(userId)._deleted;

    if(userIsArchived){
      return `people/${userId}/profile`;
    }
    else if(!this.coachingDisabled()){
      return `/people/${userId}/sprint`;
    }
    else{
      return `/people/${userId}/imperatives`;
    }
  }

  renderTeamForSalesLeader(team, isLeader){

    const teamHasLeader = team.leaders.length > 0;

    return (
      <div className="team" key={team._id}>
        <div className="name">{team.name}</div>

        {!isLeader &&
          <template>
            <h5>LEADER{team.leaders.length > 1 ? 'S' : ''}</h5>
            <ul>
              {_.map(team.leaders, leader => {
                const leaderData = this.userData(leader);

                return <Link key={leader} to={this.userLink(leader)} className={`${leaderData._deleted ? 'deleted' : ''}`}><li>{leaderData.firstName} {leaderData.lastName}</li></Link>
              })}
            </ul>
          </template>
        }

        <h6>MEMBERS</h6>
        <ul>
          {_.map(team.members, member => {
            const memberData = this.userData(member);

            return <Link key={member} to={this.userLink(member)}>
              <li className={(memberData.currentSprintStatus === 'submitted' ? 'active' : '')} className={`${memberData._deleted ? 'deleted' : ''}`}>
                <div className="member-name">{memberData.firstName} {memberData.lastName}</div>
                {!this.coachingDisabled() &&
                  <React.Fragment>
                    {teamHasLeader &&
                      <div className={`sprint-status ${memberData.currentSprintStatus}`}>{getSprintStatusTextForEmployee(memberData.currentSprintStatus)}</div>
                    }
                    <div className="hover-action">View Sprint</div>
                    {this.renderSprintHistoryForMember(memberData)}
                  </React.Fragment>
                }
              </li>
            </Link>
          })}
        </ul>

        {this.renderTeamLinks(team)}

      </div>
    )
  }

  renderTeamLink(team){
    return <Link to={`/teams/${team._id}`} key={team._id} href="google.com">{team.name}</Link>
  }

  renderTeamLinks(team){
    const linkedTeams = _.filter(this.props.teams, possiblyLinkedTeam => {
      // console.log('possiblyLinkedTeam: ', possiblyLinkedTeam);
      // console.log('team.members: ', team.members);

      //team is linked if it's leader is one of the current team's members
      return _.intersection(possiblyLinkedTeam.leaders, team.members).length > 0;
    });

    if(linkedTeams.length === 0){ return null; }

    return (
      <div className="linked-teams">
        {getIcon('network')}
        <h6>MEMBER LED TEAMS</h6>
        <p>{_.map(linkedTeams, this.renderTeamLink)}</p>
      </div>
    )
  }

  /*
  <div className="sprint-ratings">
    <div className="sprint-rating">
      <div className="manager-rating">
        <div className="rating-value" style={{height: '80%'}}></div>
      </div>
      <div className="user-rating">
        <div className="rating-value" style={{height: '60%'}}></div>
      </div>
    </div>
  </div>
  */

  renderSprintHistoryForMember(memberData){
    const memberSprintHistory = _.take(memberData.sprintHistory, 5);

    if(!memberSprintHistory || memberSprintHistory.length === 0){
      return null;
    }
    else{
      return (
        <div className="sprint-history">
          <h6>Recent sprints</h6>
          <div className="sprint-ratings fs-block">
            {_.map(memberSprintHistory, sprintHistory => {
              //const combinedScore = sprintHistory.userRating + sprintHistory.managerRating;
              const sprintDateRangeString = moment(sprintHistory.startDate).format('M/D') + '-' + moment(sprintHistory.endDate).format('M/D')
              return (
                <React.Fragment key={sprintHistory.id}>
                  <div data-for={`${sprintHistory.id}-sprint-history-ratings-tooltip`} data-tip={sprintDateRangeString + ' | User: ' + sprintHistory.userRating + '/5, Manager: ' + sprintHistory.managerRating + '/5'} className={'sprint-rating ' + getRatingClass(sprintHistory.managerRating, 5)}>{sprintHistory.managerRating}</div>
                  <ReactTooltip id={`${sprintHistory.id}-sprint-history-ratings-tooltip`} effect="solid" place="top"/>
                </React.Fragment>
              )
            })}
          </div>
        </div>
      )
    }
  }

  renderTeamForManager(team){
    return (
      <div className="team" key={team._id}>
        <div className="name">{team.name}</div>

        <ul>
          {_.map(team.members, member => {
            const memberData = this.userData(member);

            console.log('determining sprint status for member: ', memberData);

            return <Link key={member} to={`/people/${member}/sprint`}>
              <li className={(memberData.currentSprintStatus === 'submitted' ? 'active' : '')}>
                <div className="member-name">{memberData.firstName} {memberData.lastName}</div>
                <div className={`sprint-status ${memberData.currentSprintStatus}`}>{getSprintStatusTextForEmployee(memberData.currentSprintStatus)}</div>
                <div className="hover-action">View Sprint</div>
                {this.renderSprintHistoryForMember(memberData)}
              </li>
            </Link>
          })}
        </ul>

        {this.renderTeamLinks(team)}
      </div>
    )
  }

  teamsFilteredBySearch(){
    const allTeams = this.props.teams;

    const filteredTeams = _.filter(allTeams, team => {
      const teamName = team.name;

      const teamLeadersAndMembers = _.union(team.leaders, team.members);

      const teamMemberSearchString = _.reduce(teamLeadersAndMembers, (memo, userId) => {
        const userData = this.userData(userId);

        return `${memo} ${userData.firstName} ${userData.lastName} `;
      }, '');

      const teamSearchString = teamName + ' ' + teamMemberSearchString;

      return teamSearchString.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1;
    });

    return filteredTeams;
  }

  renderTeamsForAdmin(){

    const filteredTeams = this.teamsFilteredBySearch();

    const sortedTeams = _.sortBy(filteredTeams, team => {
      return team.name;
    });

    return(
      <template>
        <h1>All Teams</h1>
        <ul className="teams-list">
          {_.map(sortedTeams, this.renderTeamForAdmin.bind(this))}
        </ul>
      </template>
    )
  }

  renderTeamsForSalesLeader(){
    const filteredTeams = this.teamsFilteredBySearch();

    const sortedTeams = _.sortBy(filteredTeams, team => {
      return team.name;
    });

    const currentUserId = this.props.user.uid;

    const myTeamsSorted = _.filter(sortedTeams, team => {
      return team.leaders.indexOf(currentUserId) !== -1;
    });

    const restOfTeamsSorted = _.xor(sortedTeams, myTeamsSorted);

    return(
      <template>
        <h1>My Teams</h1>
        <ul className="teams-list">
          {_.map(myTeamsSorted, team => { return this.renderTeamForSalesLeader(team, true) })}
          {myTeamsSorted.length === 0 &&
            <p className="no-matches">No matching teams.</p>
          }
        </ul>
        <div className="section-divider" />
        <h1>All Other Teams</h1>
        <ul className="teams-list">
          {_.map(restOfTeamsSorted, team => { return this.renderTeamForSalesLeader(team, false); })}
          {restOfTeamsSorted.length === 0 &&
            <p className="no-matches">No matching teams.</p>
          }
        </ul>
      </template>
    )
  }

  getTeamsForManager(){
    const filteredTeams = this.teamsFilteredBySearch();

    const sortedTeams = _.sortBy(filteredTeams, team => {
      return team.name;
    });

    const currentUserId = this.props.user.uid;

    const myTeamsSorted = _.filter(sortedTeams, team => {
      return team.leaders.indexOf(currentUserId) !== -1;
    });

    return myTeamsSorted;
  }

  renderTeamsForManager(){
    const myTeamsSorted = this.getTeamsForManager();

    if(myTeamsSorted.length > 1){
      return (
        <template>
          <h1>My Teams</h1>
          <ul className="teams-list">
            {_.map(myTeamsSorted, this.renderTeamForManager.bind(this))}
            {myTeamsSorted.length === 0 &&
              <p className="no-matches">No matching teams.</p>
            }
          </ul>
        </template>
      )
    }
    else if(myTeamsSorted.length === 1){
      return this.renderTeamForManager(myTeamsSorted[0]);
    }
    else{
      return (
        <div className="page-section">
          <h1>My Teams</h1>
          <p>You aren't managing any teams. If this is incorrect, please contact your organization administrator.</p>
        </div>
      );
    }
  }

  renderTeams(){

    if(currentUserIsAdmin()){
      return this.renderTeamsForAdmin();
    }
    if(currentUserIsSalesLeader()){
      return this.renderTeamsForSalesLeader();
    }
    else{
      return this.renderTeamsForManager();
    }

  }

  beginCreatingNewTeam(){
    this.props.beginEditingTeam();
  }
  beginEditingTeam(teamData){
    this.props.beginEditingTeam(teamData);
  }

  renderActions(){

    if(!currentUserIsAdmin()){
      return null;
    }

    return (
      <div className="page-actions">
        <button className="button primary button-sm" onClick={this.beginCreatingNewTeam.bind(this)}>Create New Team</button>
      </div>
    );
  }

  onTeamDelete(deletedTeamData){

    console.log('deletedTeamData: ', deletedTeamData);

    this.setState({
      pageMessage: {
        messageType: 'notification',
        messageContent: '\"' + deletedTeamData.name + '\" team deleted.',
        expireAfter: 5000,
      }
    });
  }

  renderTeamSearchBox(){
    if(currentUserIsAdmin() || currentUserIsSalesLeader()){
      return <input type="text" placeholder="Search by team, leader, or member..." className="teams-search" value={this.state.searchText} onChange={(e) => { this.setState({ searchText: e.target.value }) }} />
    }
  }

  render(){

    const userRole = (this.props.user || {}).role;
    const userRoleIsManager = userRole && userRole === 'manager';

    const loading = !this.props.employees || _.size(this.props.employees) === 0 || !this.props.teams;

    return (
      <Page
        pageClass="teams all"
        permissionRequired="view_teams_page"
        loading={loading}
        hideSidebar={true}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        <div className={`teams-list-and-search ${userRoleIsManager ? 'list-only' : ''}`}>
          {this.renderTeamSearchBox()}
          {this.renderTeams()}
          {this.renderActions()}
        </div>
          <UpdateTeamModal onDelete={this.onTeamDelete.bind(this)} />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    employees: state.employees.data,
    teams: state.teams.data,
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, { beginEditingTeam })(AllTeamsPage);



// WEBPACK FOOTER //
// ./src/components/teams/all.js